import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../../utils/ModalEventListener";
import { axios_instance } from "../../../../api/axios_instance";
import { TrancheNameList } from "../../../../utils/constant";
import { checkHoldCase, holdCaseMessage } from "../../../../utils/detail";
import { toast } from "react-toastify";
import ContainerLoading from "../../../../layouts/ContainerLoading";

const WithheldChargesModal = ({
  caseDetails,
  closeWithheldChargesModal,
  withHeldChargesInputDisabled,
  withHeldChargesBtnDisplay,
  withHeldChargesPayCount,
  withHeldChargesAdjustmentAmount,
  withHeldChargesAdjustmentChargesDisplay,
  withHeldChargesAction,
  withHeldChargesOtherReasonDisplay,
  withHeldChargesCheckboxVal,
  withHeldChargesIndiCheckboxVal,
  withheldChargesInputValues,
  totalWithheldCharges,
  formFieldState,
  setFormFieldState,
  changeWithheldAmount,
}) => {
  const { finance_lead_id, id, maker_id, sub_stage } = caseDetails;
  const idx = withHeldChargesPayCount - 1;
  const updatedWithheldChargesIndiCheckboxVal = {
    ...withHeldChargesIndiCheckboxVal,
  };
  Object.values(TrancheNameList).forEach((val) => {
    if (!updatedWithheldChargesIndiCheckboxVal[val]) {
      updatedWithheldChargesIndiCheckboxVal[val] = withHeldChargesCheckboxVal;
    }
  });
  const initialState = {
    WithheldCharges: {
      ...withheldChargesInputValues,
      withHeldChargesIndiCheckboxVal: updatedWithheldChargesIndiCheckboxVal,
      withHeldChargesAction,
      withHeldChargesAdjustmentAmount: totalWithheldCharges
        ? withHeldChargesAdjustmentAmount - totalWithheldCharges
        : withHeldChargesAdjustmentAmount,
      withHeldChargesOtherReasonDisplay,
      withheldOtherReason: "",
      total_charges: totalWithheldCharges,
      withheld_fields: "",
    },
  };
  const [state, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closeWithheldChargesModal);
  }, [closeWithheldChargesModal]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      let withheldChargesResp = await axios_instance({
        url: "/dts/getWithHeldCharges",
        method: "POST",
        data: { pay_count: 1, finance_lead_id, disbursement_id: id },
        action: "getWithHeldCharges",
      });
      withheldChargesResp = withheldChargesResp.data.result;
      const WithheldCharges = state.WithheldCharges;
      WithheldCharges.withHeldChargesOtherReasonDisplay =
        withheldChargesResp &&
        withheldChargesResp.total_charges &&
        withheldChargesResp.other_charges
          ? true
          : false;
      WithheldCharges.withheldOtherReason = withheldChargesResp.other_reasons;
      WithheldCharges.total_charges = withheldChargesResp.total_charges;
      Object.keys(WithheldCharges.withHeldChargesIndiCheckboxVal).forEach(
        (input) => {
          if (withheldChargesResp[`is_${input}`] === "checked") {
            WithheldCharges.withHeldChargesAdjustmentAmount -=
              withheldChargesResp[input];
          }
          WithheldCharges.withHeldChargesIndiCheckboxVal[input] =
            withheldChargesResp[`is_${input}`] === "checked";
          WithheldCharges[input] = withheldChargesResp[input];
        }
      );
      WithheldCharges.withheld_fields = withheldChargesResp.withheld_fields;
      // console.log({
      //   witheld: WithheldCharges.withheld_fields,
      //   WithheldCharges: withheldChargesResp,
      // });
      if (parseInt(caseDetails.dts_pay_count) === 1) {
        withheldManualAutomaticInputConfiguration(
          WithheldCharges.withheld_fields,
          false
        );
      } else if (
        +withheldChargesResp?.above_one_tranche_dis === 1 &&
        parseInt(caseDetails?.dts_pay_count) > 1
      ) {
        /*let filteredFields = Object.fromEntries(
          Object.entries(WithheldCharges?.withheld_fields).filter(
            ([key]) =>
              key === "rto_charges" ||
              key === "gst_tds_charges" ||
              key === "convenience_charges"
          )
        );*/
        withheldManualAutomaticInputConfiguration(
          WithheldCharges?.withheld_fields,
          true
        );
      }

      setState((prevState) => ({
        ...prevState,
        WithheldCharges,
      }));
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const withheldManualAutomaticInputConfiguration = (
    WithheldFields,
    enabledCheckboxWithheldCharges = false
  ) => {
    const WithheldCharges = state.WithheldCharges;
    Object.keys(WithheldFields).forEach((fieldKey) => {
      const field = WithheldFields[fieldKey];
      if (
        field.read_only === 1 &&
        WithheldCharges[fieldKey] !== undefined &&
        WithheldCharges[fieldKey] !== null &&
        parseInt(WithheldCharges[fieldKey]) !== 0
      ) {
        WithheldCharges.withHeldChargesIndiCheckboxVal[fieldKey] = true;
        if (field.code === "other_charges") {
          WithheldCharges.withHeldChargesOtherReasonDisplay = true;
        }
      }
      field.disabled = field.read_only === 1;
      if (enabledCheckboxWithheldCharges) {
        field.enabledCheckboxWithheldCharges = enabledCheckboxWithheldCharges;
      }
    });
    changeTotalChargesAndAdjustmentAmount(WithheldCharges);
    setState({ ...state, WithheldCharges });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const saveWithheldCharges = async () => {
    const checkHoldStatus = await checkHoldCase(
      finance_lead_id,
      maker_id,
      sub_stage
    );
    if (checkHoldStatus) {
      toast.dismiss();
      return toast.error(holdCaseMessage, { theme: "colored" });
    }

    const totalCharges = state.WithheldCharges.total_charges;
    const adjustmentAmount =
      state.WithheldCharges.withHeldChargesAdjustmentAmount;
    const payableAmount = formFieldState[idx].netAmountVal;
    toast.dismiss();
    if (+totalCharges > +payableAmount) {
      return toast.error(
        "Withheld Amount should not be greater than Amount to be disbursed",
        { theme: "colored" }
      );
    }

    if (+adjustmentAmount < 0 && withHeldChargesAction !== "manual") {
      return toast.error("Adjustment amount should not be less than zero", {
        theme: "colored",
      });
    }

    if (+withHeldChargesPayCount === 1) {
      const paidAmount = payableAmount - totalCharges;
      formFieldState[idx].paidAmountVal = paidAmount;
      formFieldState[idx].disburse_bal_amt = totalCharges;
    }
    formFieldState[idx].with_held_charges = totalCharges;
    if (
      +formFieldState[idx].with_held_charges !==
      +formFieldState[idx].disburse_bal_amt
    ) {
      setFormFieldState([...formFieldState]);
      return toast.error(
        "Adjustment should be equal to zero. Please make appropriate changes",
        {
          theme: "colored",
        }
      );
    }
    const WithheldCharges = state.WithheldCharges;
    if (
      WithheldCharges.withHeldChargesIndiCheckboxVal.other_charges &&
      !WithheldCharges.withheldOtherReason
    ) {
      WithheldCharges.withheldOtherReasonClass = "errorInput";
      setFormFieldState([...formFieldState]);
      setState({ ...state, WithheldCharges });
      return;
    }

    try {
      const response = await axios_instance({
        url: "/dts/saveWithHeldCharges",
        method: "POST",
        data: {
          finance_lead_id: finance_lead_id,
          disbursement_id: id,
          WithheldCharges: state.WithheldCharges,
          withheld_pay_count: withHeldChargesPayCount,
          action: "save_withheld_charges",
        },
      });
      if (response.status === 200) {
        if (withHeldChargesAction === "auto") {
          changeWithheldAmount(totalCharges, true, true);
          setFormFieldState([...formFieldState]);
          return;
        }
      }
    } catch (error) {
    } finally {
      changeWithheldAmount(totalCharges, false, false);
      setFormFieldState([...formFieldState]);
      closeWithheldChargesModal();
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const newValue = value.replace(/[^\d]/g, "");
    setState({
      ...state,
      WithheldCharges: { ...state.WithheldCharges, [name]: newValue },
    });
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    if (!state.WithheldCharges.withHeldChargesIndiCheckboxVal[name]) return;
    changeTotalChargesAndAdjustmentAmount(state.WithheldCharges);
  };

  const handleCheckChange = (e) => {
    const { name, checked } = e.target;
    const WithheldCharges = state.WithheldCharges;
    if (name === "other_charges_ckd") {
      WithheldCharges.withHeldChargesOtherReasonDisplay = checked;
    }
    const indiCheckbox = name.slice(0, -4);
    WithheldCharges.withHeldChargesIndiCheckboxVal[indiCheckbox] = checked;
    changeTotalChargesAndAdjustmentAmount(WithheldCharges);
  };

  const changeTotalChargesAndAdjustmentAmount = (WithheldCharges) => {
    let value = 0;
    Object.keys(WithheldCharges.withHeldChargesIndiCheckboxVal).forEach(
      (input) => {
        if (
          !isNaN(parseFloat(WithheldCharges[input])) &&
          WithheldCharges.withHeldChargesIndiCheckboxVal[input]
        ) {
          value += parseInt(WithheldCharges[input]);
        }
      }
    );
    WithheldCharges.total_charges = value;
    WithheldCharges.withHeldChargesAdjustmentAmount =
      formFieldState[idx].disburse_bal_amt - value;
    setState({ ...state, WithheldCharges });
  };

  return ReactDOM.createPortal(
    <div className="modal-wrapper" id="modal-wrapper">
      <div className="withheldcharges-modal-content" ref={ref}>
        <div className="modal-header">
          <button
            type="button"
            className="close"
            onClick={closeWithheldChargesModal}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 className="modal-title" id="assignCheckerModal">
            Withheld Charges - Partial Payment
          </h4>
        </div>
        {!isLoading ? (
          <>
            <div className="modal-body pd-bot clearfix">
              <form id="with-held-charges-form" name="with-held-charges">
                <input
                  type="hidden"
                  name="withheld_pay_count"
                  id="withheld_pay_count"
                  value={withHeldChargesPayCount ? withHeldChargesPayCount : ""}
                  disabled={withHeldChargesInputDisabled}
                />
                <input
                  type="hidden"
                  name="withHeldChargesInputDisabled"
                  id="withheld_action"
                  value={
                    state.WithheldCharges.withHeldChargesAction
                      ? state.WithheldCharges.withHeldChargesAction
                      : ""
                  }
                  disabled={withHeldChargesInputDisabled}
                />
                {withHeldChargesAdjustmentChargesDisplay ? (
                  <div className="form-group clearfix" id="adjustment_charges">
                    <div className="col-md-12">
                      <div className="total-box">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="text-left">
                              <h5>
                                <b>Adjustment Amount</b>
                              </h5>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="text-right">
                              <h5>
                                <b>
                                  <span className="fa fa-inr"></span>
                                  <span id="adjustment_amt">
                                    {
                                      state.WithheldCharges
                                        .withHeldChargesAdjustmentAmount
                                    }
                                  </span>
                                </b>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="rto_charges_ckd"
                          id="rto_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .rto_charges
                          }
                          className="trigger inp-wh"
                          disabled={
                            state.WithheldCharges.withheld_fields?.rto_charges
                              ?.enabledCheckboxWithheldCharges
                              ? false
                              : state.WithheldCharges.withheld_fields
                                  ?.rto_charges?.disabled ||
                                withHeldChargesInputDisabled
                          }
                          onChange={handleCheckChange}
                        />
                        <label htmlFor="rto_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {state.WithheldCharges.withheld_fields?.rto_charges?.name}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="rto_charges"
                        name="rto_charges"
                        value={state.WithheldCharges.rto_charges}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields?.rto_charges
                            ?.disabled || withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="original_pending_charges_ckd"
                          id="original_pending_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .original_pending_charges
                          }
                          className="trigger inp-wh"
                          disabled={
                            state.WithheldCharges.withheld_fields
                              ?.original_pending_charges?.disabled ||
                            withHeldChargesInputDisabled
                          }
                          onChange={handleCheckChange}
                        />
                        <label htmlFor="original_pending_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields
                          ?.original_pending_charges?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="original_pending_charges"
                        name="original_pending_charges"
                        value={state.WithheldCharges.original_pending_charges}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields
                            ?.original_pending_charges?.disabled ||
                          withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="valuation_charges_ckd"
                          id="valuation_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .valuation_charges
                          }
                          className="trigger inp-wh"
                          disabled={
                            state.WithheldCharges.withheld_fields
                              ?.valuation_charges
                              ?.enabledCheckboxWithheldCharges
                              ? false
                              : state.WithheldCharges.withheld_fields
                                  ?.valuation_charges?.disabled ||
                                withHeldChargesInputDisabled
                          }
                          onChange={handleCheckChange}
                        />
                        <label htmlFor="valuation_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields?.valuation_charges
                          ?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="valuation_charges"
                        name="valuation_charges"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.valuation_charges}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields
                            ?.valuation_charges?.disabled ||
                          withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="processing_charges_ckd"
                          id="processing_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .processing_charges
                          }
                          className="trigger inp-wh"
                          disabled={
                            state.WithheldCharges.withheld_fields
                              ?.processing_charges
                              ?.enabledCheckboxWithheldCharges
                              ? false
                              : state.WithheldCharges.withheld_fields
                                  ?.processing_charges?.disabled ||
                                withHeldChargesInputDisabled
                          }
                          onChange={handleCheckChange}
                        />
                        <label htmlFor="processing_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields
                          ?.processing_charges?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="processing_charges"
                        name="processing_charges"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.processing_charges}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields
                            ?.processing_charges?.disabled ||
                          withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="bank_noc_charges_ckd"
                          id="bank_noc_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .bank_noc_charges
                          }
                          className="trigger inp-wh"
                          onChange={handleCheckChange}
                          disabled={
                            state.WithheldCharges.withheld_fields
                              ?.bank_noc_charges?.disabled ||
                            withHeldChargesInputDisabled
                          }
                        />
                        <label htmlFor="bank_noc_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields?.bank_noc_charges
                          ?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="bank_noc_charges"
                        name="bank_noc_charges"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.bank_noc_charges}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields
                            ?.bank_noc_charges?.disabled ||
                          withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="seller_presence_charges_ckd"
                          id="seller_presence_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .seller_presence_charges
                          }
                          className="trigger inp-wh"
                          onChange={handleCheckChange}
                          disabled={
                            state.WithheldCharges.withheld_fields
                              ?.seller_presence_charges?.disabled ||
                            withHeldChargesInputDisabled
                          }
                        />
                        <label htmlFor="seller_presence_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields
                          ?.seller_presence_charges?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="seller_presence_charges"
                        name="seller_presence_charges"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.seller_presence_charges}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields
                            ?.seller_presence_charges?.disabled ||
                          withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="dealer_rc_charges_ckd"
                          id="dealer_rc_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .dealer_rc_charges
                          }
                          className="trigger inp-wh"
                          onChange={handleCheckChange}
                          disabled={
                            state.WithheldCharges.withheld_fields
                              ?.dealer_rc_charges?.disabled ||
                            withHeldChargesInputDisabled
                          }
                        />
                        <label htmlFor="dealer_rc_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields?.dealer_rc_charges
                          ?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="dealer_rc_charges"
                        name="dealer_rc_charges"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.dealer_rc_charges}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields
                            ?.dealer_rc_charges?.disabled ||
                          withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="split_payment_charges_ckd"
                          id="split_payment_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .split_payment_charges
                          }
                          className="trigger inp-wh"
                          disabled={
                            state.WithheldCharges.withheld_fields
                              ?.split_payment_charges?.disabled ||
                            withHeldChargesInputDisabled
                          }
                          onChange={handleCheckChange}
                        />
                        <label htmlFor="split_payment_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields
                          ?.split_payment_charges?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="split_payment_charges"
                        name="split_payment_charges"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.split_payment_charges}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields
                            ?.split_payment_charges?.disabled ||
                          withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="convenience_charges_ckd"
                          id="convenience_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .convenience_charges
                          }
                          className="trigger inp-wh"
                          onChange={handleCheckChange}
                          disabled={
                            state.WithheldCharges.withheld_fields
                              ?.convenience_charges
                              ?.enabledCheckboxWithheldCharges
                              ? false
                              : state.WithheldCharges.withheld_fields
                                  ?.convenience_charges?.disabled ||
                                withHeldChargesInputDisabled
                          }
                        />
                        <label htmlFor="convenience_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields
                          ?.convenience_charges?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="convenience_charges"
                        name="convenience_charges"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.convenience_charges}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields
                            ?.convenience_charges?.disabled ||
                          withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="foreclosure_charges_ckd"
                          id="foreclosure_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .foreclosure_charges
                          }
                          className="trigger inp-wh"
                          disabled={
                            state.WithheldCharges.withheld_fields
                              ?.foreclosure_charges?.disabled ||
                            withHeldChargesInputDisabled
                          }
                          onChange={handleCheckChange}
                        />
                        <label htmlFor="foreclosure_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields
                          ?.foreclosure_charges?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="foreclosure_charges"
                        name="foreclosure_charges"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.foreclosure_charges}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields
                            ?.foreclosure_charges?.disabled ||
                          withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="gst_tds_charges_ckd"
                          id="gst_tds_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .gst_tds_charges
                          }
                          className="trigger inp-wh"
                          disabled={
                            state.WithheldCharges.withheld_fields
                              ?.gst_tds_charges?.enabledCheckboxWithheldCharges
                              ? false
                              : state.WithheldCharges.withheld_fields
                                  ?.gst_tds_charges?.disabled ||
                                withHeldChargesInputDisabled
                          }
                          onChange={handleCheckChange}
                        />
                        <label htmlFor="gst_tds_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields?.gst_tds_charges
                          ?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="gst_tds_charges"
                        name="gst_tds_charges"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.gst_tds_charges}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields?.gst_tds_charges
                            ?.disabled || withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="pdd_pending_ckd"
                          id="pdd_pending_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .pdd_pending
                          }
                          className="trigger inp-wh"
                          disabled={
                            state.WithheldCharges.withheld_fields?.pdd_pending
                              ?.disabled || withHeldChargesInputDisabled
                          }
                          onChange={handleCheckChange}
                        />
                        <label htmlFor="pdd_pending_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {state.WithheldCharges.withheld_fields?.pdd_pending?.name}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="pdd_pending"
                        name="pdd_pending"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.pdd_pending}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields?.pdd_pending
                            ?.disabled || withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group clearfix">
                  <div className="col-md-1">
                    <div className="text-label">
                      <span className="">
                        <input
                          type="checkbox"
                          name="other_charges_ckd"
                          id="other_charges_ckd"
                          checked={
                            state.WithheldCharges.withHeldChargesIndiCheckboxVal
                              .other_charges
                          }
                          className="trigger inp-wh"
                          disabled={
                            state.WithheldCharges.withheld_fields?.other_charges
                              ?.disabled || withHeldChargesInputDisabled
                          }
                          onChange={handleCheckChange}
                        />
                        <label htmlFor="other_charges_ckd">
                          <span className="dt-yes"></span>
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="text-label text-right">
                      {
                        state.WithheldCharges.withheld_fields?.other_charges
                          ?.name
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-group">
                      <span className="input-group-addon rupee-icon inp"></span>
                      <input
                        type="text"
                        className="form-control text-right calc-withheld"
                        id="other_charges"
                        name="other_charges"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={state.WithheldCharges.other_charges}
                        placeholder=""
                        disabled={
                          state.WithheldCharges.withheld_fields?.other_charges
                            ?.disabled || withHeldChargesInputDisabled
                        }
                      />
                    </div>
                  </div>
                </div>
                {state.WithheldCharges.withHeldChargesOtherReasonDisplay ? (
                  <div className="form-group clearfix withheld_other_reason">
                    <div className="col-md-12">
                      <div className="text-label">
                        <textarea
                          className={`form-control ${state.WithheldCharges.withheldOtherReasonClass}`}
                          rows="1"
                          cols="67"
                          id="withheld_other_reason"
                          name="withheld_other_reason"
                          placeholder="Please mention details for Other here..."
                          value={state.WithheldCharges.withheldOtherReason}
                          onChange={(e) =>
                            setState({
                              ...state,
                              WithheldCharges: {
                                ...state.WithheldCharges,
                                withheldOtherReason: e.target.value,
                              },
                            })
                          }
                        ></textarea>
                        <div
                          className="errorTxt"
                          id="error_withheld_other_reason"
                        ></div>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="form-group clearfix">
                  <div className="col-md-12">
                    <div className="total-box">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="text-right">
                            <h5>
                              <b>Total Withheld Amount</b>
                            </h5>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="text-right">
                            <input
                              type="hidden"
                              id="total_withheld_charges"
                              name="total_withheld_charges"
                              value={state.WithheldCharges.total_charges}
                              disabled={withHeldChargesInputDisabled}
                            />
                            <div>
                              <h5>
                                <b>
                                  <span className="fa fa-inr"></span>
                                  <span className="withheld-sum">
                                    {state.WithheldCharges.total_charges
                                      ? state.WithheldCharges.total_charges
                                      : "0"}
                                  </span>
                                </b>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            {withHeldChargesBtnDisplay ? (
              <div className="modal-footer txt-cnt" id="with_held_save_btn">
                <button
                  type="button"
                  className="btn rc-btn_primary btn-lg"
                  onClick={() => saveWithheldCharges()}
                >
                  Save
                </button>
              </div>
            ) : (
              <></>
            )}
          </>
        ) : (
          <ContainerLoading galleryLoader={true} />
        )}
      </div>
    </div>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default WithheldChargesModal;
